export class GoalValidationConstants {

    static readonly NAME_MAX_LENGTH: number = 255;
    static readonly DESCRIPTION_MAX_LENGTH: number = 500;
}
